import type { FC } from "react";
import { WidgetTitle } from "app/components/widget-title/WidgetTitle";
import type { IIndustryOverviewTitleProps } from "./IndustryOverviewTitle.types";
import { TitleContainer } from "./IndustryOverviewTitle.styles";
import { IndustryOverviewAddToDashboard } from "./IndustryOverviewAddToDashboard";
import { useNoRenderA2D } from "app/pages/industry-analysis/frame/WithNoRender";

export const IndustryOverviewTitle: FC<IIndustryOverviewTitleProps> = (props) => {
    const { services, headerProps, addToDashboardProps } = props;

    const { isA2DAvailable } = useNoRenderA2D();
    const isAvailable = addToDashboardProps.isVisible && isA2DAvailable;

    return (
        <TitleContainer>
            <WidgetTitle
                title={headerProps.title}
                tooltip={headerProps?.tooltip}
                displayBetaLabel={headerProps?.displayBetaLabel}
                filters={headerProps.filters}
            />
            {isAvailable && (
                <IndustryOverviewAddToDashboard
                    services={services}
                    type={addToDashboardProps.type}
                    metric={addToDashboardProps.metric}
                    overrideParams={addToDashboardProps.overrideParams}
                />
            )}
        </TitleContainer>
    );
};
